import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

export type RouteHandlerState = {
  routeHandler: RouteHandlerOptions;
};

export interface RouteHandlerOptions {
  removeOnRouteChangeStartListener?: () => void;
  removeOnRouteChangeCompleteListener?: () => void;
  removeOnBeforeUnloadListener?: () => void;
}

const initState: RouteHandlerState = {
  routeHandler: {},
};

export const useRouteHandler = createStore({
  name: 'route-handler',
  devtools: true,
  persist: false,
})(initState as RouteHandlerState, set => {
  const handler = stateSetterHandler(set);
  return {
    setRouteHandler: handler('routeHandler'),
  };
});
